import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { WRAPPER_TYPES } from 'site-modules/shared/components/faq/constants';
import { transformContentForFaq } from 'site-modules/shared/components/faq/utils';
import { Faq } from 'site-modules/shared/components/faq/faq';
import { AppraisalUserTestimonials } from 'site-modules/shared/components/appraisal-user-testimonials/appraisal-user-testimonials';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';

import './appraisal-promotions-info-section.scss';

export function AppraisalPromotionsInfoSection({
  testimonials = DEFAULT_CONTENT,
  isMobile = false,
  faqContent = DEFAULT_CONTENT,
  pathname = '',
}) {
  return (
    <div className="appraisal-promotions-info-section">
      <ErrorBoundary>
        <AppraisalUserTestimonials
          testimonials={testimonials}
          subheading="Join thousands of happy customers who redeemed an offer using Edmunds."
          title="What people say"
          isMobile={isMobile}
          titleClassName="heading-3 mb-0_75"
        />
      </ErrorBoundary>
      <Faq
        {...transformContentForFaq(faqContent)}
        title="FAQ"
        wrapperType={WRAPPER_TYPES.accordion}
        pathname={pathname}
        generateLearnMoreLinks
        isOpenCollapseOnLoad={false}
        visibleEntriesNum={5}
      />
    </div>
  );
}

AppraisalPromotionsInfoSection.propTypes = {
  testimonials: CmsEntities.Content,
  isMobile: PropTypes.bool,
  faqContent: CmsEntities.Content,
  pathname: PropTypes.string,
};
